<template>
  <div
    class="descope-signup-widget-view"
    :style="style"
  >
    <div
      v-if="!widget.descopeFlowId"
      class="placeholder-content"
    >
      <div class="placeholder-text">
        <h3>Descope Signup Widget</h3>
        <p>Configure the Descope Flow Id in the editor to display the signup form.</p>
      </div>
    </div>
    <div
      v-else
      class="descope-flow-container"
    >
      <Descope
        :client="{
          anonymousUserId: anonymousUserId,
          utmParams,
          contextPageReferrer,
          emailLogoUrl: widget.emailLogoUrl,
          emailButtonBackgroundColor: widget.emailButtonBackgroundColor,
          emailButtonFontColor: widget.emailButtonFontColor,
          emailButtonFontFamily: widget.emailButtonFontFamily,
          emailButtonFontSize: widget.emailButtonFontSize,
          flowId: widget.descopeFlowId,
          market: widget.market || 'UK',
        }"
        :error-transformer="errorTransformer"
        :flow-id="widget.descopeFlowId"
        @error="handleDescopeError"
        @success="handleDescopeSuccess"
      />
    </div>
  </div>
</template>

<script>
import { Descope } from '@descope/vue-sdk';
// Import necessary utilities and services
import anonymousSession from '../../../../../anonymousSession';
import { errorTransformer, handleDescopeError as handleError } from '../../../../../utils/errorHandling';

export default {
  name: 'DescopeSignupWidgetView',
  components: {
    Descope,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      anonymousUserId: null,
      utmParams: {},
      contextPageReferrer: document.referrer,
    };
  },
  computed: {
    style() {
      // Widget now fills e
      return {
        top: `${this.widget.top}px`,
      };
    },
  },
  mounted() {
    this.setupAnonymousSession();
    this.extractUtmParams();
  },
  methods: {

    setupAnonymousSession() {
      // Set up anonymous session similar to DescopeOtsSignup
      this.anonymousUserId = anonymousSession.getId();
    },

    extractUtmParams() {
      // Extract UTM parameters from URL if available
      const urlParams = new URLSearchParams(window.location.search);
      const utmParams = {};

      for (const [key, value] of urlParams.entries()) {
        if (key.startsWith('utm_') && value) {
          utmParams[key] = value;
        }
      }

      this.utmParams = utmParams;
    },

    errorTransformer(error) {
      return errorTransformer(error);
    },

    handleDescopeError(error) {
      console.error('Descope signup error in widget:', error);
      handleError(error);

      // Emit error event for parent components
      this.$emit('userInteraction', {
        eventName: 'signupError',
        data: { error },
      });
    },

    handleDescopeSuccess(e) {
      console.log('Descope signup success in widget:', e.detail);

      // Handle successful signup - simplified version
      const { user } = e.detail;
      const { sessionJwt } = e.detail;

      // Emit success event for parent components
      this.$emit('userInteraction', {
        eventName: 'signupSuccess',
        data: {
          user,
          sessionJwt,
          flowId: this.widget.descopeFlowId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.descope-signup-widget-view {
  // Override widget position properties to fill entire screen
  overflow-y: auto;
  scroll-behavior: smooth;
  width: 430px;
  position: absolute;
  left: 0;

  // Keep font styling from widget properties
  font-family: v-bind('widget.fontFamily');
  color: v-bind('widget.fontColor');

  .placeholder-content {
    text-align: center;
    padding: 40px 20px;
    width: 100%;
    box-sizing: border-box;

    .placeholder-text {
      h3 {
        margin-bottom: 15px;
        color: inherit;
      }

      p {
        color: #666;
        margin: 0;
      }
    }
  }

  .descope-flow-container {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    --ots-primary-main: v-bind('widget.descopeButtonColor || "#5d7afd"');
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
